import { Grid } from "@mui/material";
import React from "react";
import QTDetailsTextFieldWithLabelSection from "../../../../../common/QTDetailsTextFieldWithLabelSection";
import moment from "moment";

const ReportDetailsDataFieldsSection = ({ reportDetails }) => {
  return (
    <Grid container style={dataContainerStyles}>
      {/*left side column*/}
      <Grid item container direction={"column"} xs>
        {/*Report ID section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Reported ID"}
          value={reportDetails?.id}
          disabled={true}
        />
        {/*QT Title or user Name section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Title/Name"}
          value={reportDetails?.title}
          disabled={true}
        />
        {/*QT id or User ID section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Reported Item ID"}
          value={reportDetails?.reportedItemId}
          disabled={true}
        />
        {/*report details section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Reported Details"}
          value={reportDetails?.details}
          disabled={true}
          multiline={true}
          rows={3}
        />
      </Grid>
      {/*right side column*/}
      <Grid item container direction={"column"} xs>
        {/*Report Type section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Reported Type"}
          value={reportDetails?.type}
          disabled={true}
        />
        {/*Reporter User section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Reporter User"}
          value={reportDetails?.reportedByData?.userName}
          disabled={true}
        />
        {/*Report reason section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Reported Reason"}
          value={reportDetails.reason}
          disabled={true}
        />
        {/*Creation Date section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Reported Date"}
          value={
            reportDetails?.createdAt &&
            moment(new Date(reportDetails.createdAt.seconds * 1000)).format(
              "MM/DD/YYYY HH:mm:ss"
            )
          }
          disabled={true}
          // editEnabled={editEnabled}
        />
      </Grid>
    </Grid>
  );
};

export default ReportDetailsDataFieldsSection;

const dataContainerStyles = {
  borderRadius: 12,
  boxShadow: " 0px 0px 30px 0px rgba(80, 85, 136, 0.15)",
  background: "var(--gray-99, #FCFCFC)",
  padding: "36px 15px",
};
